<style lang="scss"  scoped>
div#notificationsBar {
    position: fixed;
    bottom: -100%;
    width: 100%;
    min-height: 0px;
    z-index:99999;
    text-transform: uppercase;
    font-size: 1rem;
    transition: all 400ms;
    left: 0;

    &.appear{
        bottom:0px;
    }

    &.error, &.danger {
        background-color: #e7505a;
        border-color: #e7505a;
    }

    &.warning, &.alert {
        background-color: #ffb822;
        border-color: #ffb822;
    }

    &.success {
        background-color: #64ca7c;
        border-color: #64ca7c;
    }

    &.info {
        background-color: #36a3f7;
        border-color: #36a3f7;
    }

    div.row {
        padding: 13px 15px 10px 15px;

        div.message {
            color: white;
            font-size: .75rem;
            text-align: center;
            font-weight: 300;
        }
    }
}
</style>

<template>
    <div id="notificationsBar" v-if="show" :class="[type, appear]">
        <div class="row no-gutters">
            <div class="col">
                <div class="message" v-html="message"></div>
            </div>
            <div class="col-auto text-white" @click="show = false">
                <i class="la la-times"></i>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data: function () {
        return {
            message: '',
            type: 'error',
            show: false,
            appear: '',
        };
    },
    created() {
        this.$eventHub.$on('notification', payload => {
            this.message = payload.message;
            if (payload.type != undefined) {
                this.type = payload.type;
            }

            this.show = true;

            setTimeout(
                () => {
                    this.appear = 'appear';
                }, 100)

            var time;

            if (payload.time) {
                time = payload.time;
            } else {
                time = 6;
            }

            var self = this;

            setTimeout(
                () =>{
                    self.appear = '';

                    setTimeout(
                        () =>{
                            self.show = false;
                        }, 500)

                }
                , time * 1000);
        });

    },
    beforeDestroy() {
        this.$eventHub.$off('notification');
    },
}
</script>
